import React, { useState, useEffect } from "react";
import "./HeroSlider.css";
import LandingPage from './LandingPage';
import LandingPage1 from './LandingPage1';
import ServicesPage from './ServicesPage';
import ContactSection from './ContactSection';
import {
  FaTruck,
  FaTruckMoving
} from "react-icons/fa";

import {
  GiCrane
} from "react-icons/gi";

export default function HeroSlider() {
  const images = [
    "/img1.jpeg",
    "/img2.jpeg",
    "/img3.jpeg",
  ];


const icons = [
  {
    icon: <GiCrane />,
    text: "מנופים"
  },
  {
    icon: <FaTruck />,
    text: "משאיות"
  },
  {
    icon: <FaTruckMoving />,
    text: "הובלות מורכבות"
  }

];

  const [index, setIndex] = useState(0);

  // מעבר אוטומטי כל 3 שניות
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

return (
    <>

  <div className="slider-container">

    {/* סליידר מסך מלא */}
    <img src={images[index]} alt="slider" className="main-slider" />

    {/* צד ימין קבוע */}
    <div className="right-overlay">

      {/* כותרת */}
<div className="hero-text">

  <h3 className="overlay-title">
    נצר הובלות ומנופים
  </h3>

  <h2>
    ברוכים הבאים לנצר הובלות ומנופים
  </h2>
<h2> הובלות ומנופים בפריסה ארצית </h2>
<h2>   פתרונות מקצועיים להובלה, הרמה ושינוע לכל סוגי הפרויקטים  </h2>


  <h2> ביצוע מדויק, ציוד מתקדם ושירות ללא פשרות !
  </h2>



</div>

<div className="images-row">
  {icons.map((item, i) => (
    <div className="icon-box" key={i}>
      <div className="service-icon">
        {item.icon}
      </div>

      <span>{item.text}</span>
    </div>
  ))}
</div>
      </div>
    </div>

    {/* 🔥 חשוב: הדפים מחוץ לסליידר */}
       <ServicesPage />
          <LandingPage/>
     
    <LandingPage1 />
   <ContactSection />
  </>
);
}